export const SALE_RETAINER_STATUS = {
  FOR_INVOICE: 'for-invoice',
  INVOICED: 'invoiced',
  VOIDED: 'voided'
}
